import { openContextModal } from "@mantine/modals";
import { getI18n } from "react-i18next";

import { ReportIssueModalInnerProps } from "./ReportIssueModal";

export const openReportIssueModal = (innerProps: ReportIssueModalInnerProps) => {
	openContextModal({
		modal: "reportIssue",
		innerProps,
		title: String(getI18n().t("report_issue_modal.title")),
		styles: {
			// Ключ 'modal' переименован в 'content' для стилизации самого окна.
			content: {
				// Значения цветов из темы заменены на CSS-переменные.
				color: "var(--mantine-color-black)",
				backgroundColor: "var(--mantine-color-white)"
			},
			// Стили для кнопки закрытия.
			close: {
				color: "var(--mantine-color-gray-6)",
				// Псевдо-селектор :hover остается, но цвет также указывается через CSS-переменную.
				"&:hover": {
					backgroundColor: "var(--mantine-color-gray-0)"
				}
			}
		}
	});
};
